<template>
    <div>
        <Loader :loader="loader" :showMessage="false" />
        <c-input
            v-if="!loader"
            :id="id"
            :label="label"
            :value.sync="value"
            :state="state"
            :labelClass="labelClass"
            classes="d-none"
        >
            <b-button-group
                class="d-block"
                slot="check-in-by-range"
                :vertical="isVertical"
            >
                <b-button
                    :id="`popover-for-range-${range.id}`"
                    :key="range.id"
                    v-for="range in ranges"
                    @click="onClickRange(range.id)"
                    :style="
                        !isVertical
                            ? { width: getButtonWidthInPercent(ranges.length) }
                            : null
                    "
                    :variant="options[range.id] ? 'primary' : 'outline-primary'"
                    class="text-truncate"
                >
                    {{ range.title }}
                </b-button>
            </b-button-group>
            <b-popover
                :key="range.id"
                v-for="range in ranges"
                :target="`popover-for-range-${range.id}`"
                triggers="hover"
                placement="bottomright"
            >
                <template slot="title">
                    {{ range.title }} | {{ range.target }}%
                </template>
                <p class="mb-1" v-if="range.value != null">
                    {{ $t('targets.target') }}: {{ range.value }}
                </p>
                <p class="mb-0" v-if="range.description">
                    {{ range.description }}
                </p>
            </b-popover>
            <slot />
        </c-input>
    </div>
</template>

<script>
import { getRangesFromAPI } from '../../api'
import CInput from './CInput'
import Loader from '@/views/components/loader'

export default {
    name: 'CCheckInByRange',
    components: {
        CInput,
        Loader,
    },
    props: [
        'id',
        'value',
        'state',
        'label',
        'labelClass',
        'selected',
        'goalRanges',
    ],
    data() {
        return {
            loader: true,
            ranges: [],
            options: {},
            optionsInitialState: {},
            windowWidth: 0,
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.getWindowWidth)
            this.getWindowWidth()
        })
        getRangesFromAPI().then(resp => {
            const ranges = resp.data.data.data

            this.optionsInitialState = this.options = this.mapperRangesFromApiToRangesInitialState(
                ranges
            )

            this.ranges = this.mapperApiToForm(ranges, this.goalRanges)

            this.setSelectedRange(this.selected)
            this.loader = false
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth)
    },
    computed: {
        isVertical() {
            return this.windowWidth <= 575
        },
    },
    methods: {
        getButtonWidthInPercent(amount) {
            return 100 / amount + '%'
        },
        mapperRangesFromApiToRangesInitialState(ranges) {
            let rangesInitialState = {}
            ranges.forEach(range => {
                rangesInitialState = {
                    ...rangesInitialState,
                    [range.id]: false,
                }
            })
            return rangesInitialState
        },
        mapperApiToForm(ranges, goalRanges) {
            if (!goalRanges.length) {
                return ranges.map(range => {
                    const { id, title, target } = range
                    return { id, title, target, description: null, value: null }
                })
            } else {
                if (goalRanges.every(range => range.value === null)) {
                    return ranges.map(range => {
                        const { id, title, target } = range
                        const goalRange = goalRanges.find(
                            goalRange => goalRange.id == id
                        )
                        let description = goalRange
                            ? goalRange.description
                            : null
                        return { id, title, target, description, value: null }
                    })
                } else {
                    const goalRangesFiltered = goalRanges.filter(range => {
                        return range.value !== null
                    })
                    const generalRangesFiltered = []
                    ranges.forEach(range => {
                        goalRangesFiltered.forEach(goalRange => {
                            if (range.id == goalRange.id) {
                                range.value = goalRange.value
                                range.description = goalRange.description
                                generalRangesFiltered.push(range)
                            }
                        })
                    })
                    return generalRangesFiltered.map(range => {
                        const { id, title, target, description, value } = range
                        return { id, title, target, description, value }
                    })
                }
            }
        },
        setSelectedRange(key) {
            const oldStatus = this.options[key]
            this.options = { ...this.optionsInitialState }
            this.options[key] = !oldStatus
        },
        onClickRange(key) {
            this.setSelectedRange(key)
            const isSelected = this.options[key]
            this.$emit('update:selected', isSelected ? key : null)
            this.$emit(
                'update:value',
                isSelected ? this.getRangeTargetById(key) : null
            )
        },
        getRangeTargetById(id) {
            const range = this.ranges.find(rangeData => rangeData.id == id)
            if (range.value !== null) {
                return range.value
            } else {
                return range.target
            }
        },
        getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth
        },
    },
}
</script>
